import { render } from "./DneApp.vue?vue&type=template&id=048709fc&scoped=true"
import script from "./DneApp.vue?vue&type=script&lang=js"
export * from "./DneApp.vue?vue&type=script&lang=js"

import "./custom-dne-app.scss?vue&type=style&index=0&id=048709fc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048709fc"]])

export default __exports__